import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-57b0e178"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "Chapter__Hover color--3"
}
const _hoisted_2 = { class: "Chapter__Inner" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "Chapter__Picture__Background color--1" }, null, -1))
const _hoisted_4 = {
  key: 1,
  class: "Chapter__Picture"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "Chapter__Picture__Background color--1" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 60 116",
  class: "color--5"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#i-keyhole" })
], -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = { class: "Chapter__Content" }
const _hoisted_9 = { class: "Chapter__Time small-uppercase color--3" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = {
  key: 2,
  class: "Chapter__Status Chapter__Status--completed color--2"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 12 8" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#i-checked" })
], -1))
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = {
  key: 3,
  class: "Chapter__Status Chapter__Status--opened color--2"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "border",
  viewBox: "0 0 56 41"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#i-arrow-button-border" })
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "border",
  viewBox: "0 0 56 41"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#i-arrow-button-border" })
], -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "arrow" }, [
  /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 17 14" }, [
    /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#i-arrow-right--alt" })
  ])
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "arrow arrow--hover" }, [
  /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 17 14" }, [
    /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#i-arrow-right--alt" })
  ])
], -1))
const _hoisted_20 = [
  _hoisted_16,
  _hoisted_17,
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = {
  key: 4,
  class: "Chapter__Status Chapter__Status--progress color--2"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", null, "%", -1))
const _hoisted_23 = {
  key: 5,
  class: "Chapter__Status Chapter__Status--closed color--2"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 21 21" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#i-locked" })
], -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = {
  key: 6,
  class: "Chapter__Unpublished"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LazyPicture = _resolveComponent("LazyPicture")!

  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.chapter.status === 'opened' ? 'router-link' : 'div'), {
    to: _ctx.chapter.status === 'opened' ? `/chapter/${_ctx.chapter.slug}`: '',
    class: _normalizeClass(['Chapter', 'Chapter--'+_ctx.chapter.status])
  }, {
    default: _withCtx(() => [
      (_ctx.chapter.status === 'opened')
        ? (_openBlock(), _createElementBlock("span", _hoisted_1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        (_ctx.chapter.status === 'opened')
          ? (_openBlock(), _createBlock(_component_LazyPicture, {
              key: 0,
              class: "Chapter__Picture",
              image: _ctx.chapter.thumbnail,
              alt: _ctx.course.title
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }, 8, ["image", "alt"]))
          : _createCommentVNode("", true),
        (_ctx.chapter.status === 'closed')
          ? (_openBlock(), _createElementBlock("picture", _hoisted_4, _hoisted_7))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('course.minutes', { duration: _ctx.chapter.readTime })), 1),
          _createElementVNode("h3", {
            class: "color--2",
            innerHTML: _ctx.chapter.title
          }, null, 8, _hoisted_10)
        ]),
        (_ctx.chapter.status == 'opened' && _ctx.chapter.progress === 100)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_14))
          : _createCommentVNode("", true),
        (_ctx.chapter.status == 'opened' && _ctx.chapter.progress === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_20))
          : _createCommentVNode("", true),
        (_ctx.chapter.status == 'opened' && _ctx.chapter.progress > 0 && _ctx.chapter.progress < 100)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createTextVNode(_toDisplayString(Math.round(_ctx.chapter.progress)), 1),
              _hoisted_22
            ]))
          : _createCommentVNode("", true),
        (_ctx.chapter.status == 'closed')
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_25))
          : _createCommentVNode("", true),
        (!_ctx.chapter.published)
          ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_ctx.$t('chapter.unpublished')), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["to", "class"]))
}